export const REGISTRATION_FORM = 'REGISTRATION_FORM_POST';

export const types = {
    POST_REQUEST: `${REGISTRATION_FORM}_REQUEST`,
    POST_SUCCESS: `${REGISTRATION_FORM}_SUCCESS`,
    POST_FAILURE: `${REGISTRATION_FORM}_FAILURE`,
};

